// تأكد من أنك قمت بتهيئة Firebase مسبقًا في مشروعك
import firebase from 'firebase/app';
import 'firebase/firestore';

export function setupVersionListener() {
  const db = firebase.firestore();
  
  // المرجع لمستند الإصدار في Firestore
  const versionDocRef = db.collection('appUpdates').doc('version');

  versionDocRef.onSnapshot((doc) => {
    if (!doc.exists) {
      console.error('مستند الإصدار غير موجود!');
      return;
    }

    // قراءة قيمة الإصدار من Firestore
    const serverVersion = doc.data().version;

    // قراءة الإصدار المحلي المخزن في localStorage (افتراضيًا "1.0.0" إذا لم يكن موجود)
    const localVersion = localStorage.getItem('appVersion') || '1.0.0';

    console.log(`الإصدار المحلي: ${localVersion} - الإصدار على السيرفر: ${serverVersion}`);

    // إذا كانت قيمة الإصدار مختلفة، فهذا يعني أنه تم نشر تحديث جديد
    if (serverVersion !== localVersion) {
      // تحديث الإصدار المخزن محليًا
      localStorage.setItem('appVersion', serverVersion);
      console.log('تم الكشف عن إصدار جديد! جاري إعادة تحميل الصفحة...');
      // إعادة تحميل الصفحة لجلب النسخة الجديدة
      window.location.reload();
    }
  }, (error) => {
    console.error('خطأ في مراقبة مستند الإصدار:', error);
  });
}



// WEBPACK FOOTER //
// ./src/checkForUpdates.js